let inFlight: AbortController | null = null;

/**
 * Runs `selection` as the only bookmark selection allowed to finish: it aborts whatever
 * selection was in flight and is itself aborted by the next one, no matter which component
 * started. Loading a bookmark belongs inside the selection, so that a load losing the race is
 * dropped rather than applied on top of a newer bookmark.
 */
export async function runBookmarkSelection(selection: (signal: AbortSignal) => Promise<void>): Promise<void> {
    inFlight?.abort();
    const controller = new AbortController();
    inFlight = controller;

    try {
        await selection(controller.signal);
    } finally {
        if (inFlight === controller) {
            inFlight = null;
        }
    }
}
